import { render, staticRenderFns } from "./carrier.vue?vue&type=template&id=60ceb61f&scoped=true"
import script from "./carrier.vue?vue&type=script&lang=js"
export * from "./carrier.vue?vue&type=script&lang=js"
import style0 from "./carrier.vue?vue&type=style&index=0&id=60ceb61f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ceb61f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60ceb61f')) {
      api.createRecord('60ceb61f', component.options)
    } else {
      api.reload('60ceb61f', component.options)
    }
    module.hot.accept("./carrier.vue?vue&type=template&id=60ceb61f&scoped=true", function () {
      api.rerender('60ceb61f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/base-data/carrier.vue"
export default component.exports